module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9kKFhYGOk7aVlMAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAFVBMVEX4gHiAeHCIaDC4oDjgwGj4+Pj///8/0o0gAAAAAXRSTlMAQObYZgAAAAFiS0dEBmFmuH0AAABiSURBVAjXY2BxQQEODM7GKMCEwRgNAAVMQ4WNwchUOBAiIBgIRaLCEAHhQDASNA2EawELAGWgAqIwAZgKwUCoLoQZhqGCQASUAQsYCgsaCwoDEYhhjOkwZVS+EQOTEgpQAAC26yoftBkO5QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Rock.png
// module id = 172
// module chunks = 0